module.exports = __webpack_public_path__ + "041fe6a6.svg";